(function ($) {
    function buildToggleMenu() {
        var site_menu = $("#site__menu");
        var menu_toggle = $("#toggle__menu");
        var body = $("body");
        var secondary_menus = site_menu.find("nav").not("#menu--primary");
        var brand_bar = $("#brand__bar");
        var panel_mega = $(".panel__mega");
        var resources_toggle = $("#toggle__resources");
        var logins_toggle = $("#toggle__logins");
        var personas_toggle = $("#toggle__personas");
        var resources_panel = $("#panel__resources");
        var logins_panel = $("#panel__logins");
        var personas_panel = $("#panel__personas");

        // Toggle menu when tapping the button
        menu_toggle.click(function () {
            body.toggleClass("clip");
            body.toggleClass("mobile-nav-shown");
            menu_toggle.toggleClass("toggle__menu--active");
            brand_bar.toggleClass("brand__bar--active");

            if ($("#menu--primary").length > 0) {
                site_menu.toggleClass("site__menu--active");
                resources_panel.removeClass("panel__resources--active");
                logins_panel.removeClass("panel__logins--active");
                personas_panel.removeClass("panel__personas--active");
                resources_toggle.removeClass("toggle__resources--active");
                logins_toggle.removeClass("toggle__logins--active");
                personas_toggle.removeClass("toggle__personas--active");
            }
        });
    }

    function destroyToggleMenu() {
        var menu_toggle = $("#toggle__menu");
        var site_menu = $("#site__menu");
        var secondary_menus = site_menu.find("nav").not(":first-child");

        // Unbind menu toggle & remove
        menu_toggle.unbind("click").remove();
    }

    function buildBrandBar() {
        var search_toggle = $("#toggle__search");
        var alert_toggle = $("#toggle__alert");
        var search_panel = $("#panel__search");

        var brand_bar = $("#brand__bar");

        // Move components from site bar to brand bar
        alert_toggle.prependTo(brand_bar.find(".wrapper"));
        search_toggle.appendTo(brand_bar.find(".wrapper"));

        // Add panels to brand bar
        search_panel.insertAfter(brand_bar);
    }

    function brandToggles() {
        var logins_panel = $("#panel__logins");
        var resources_panel = $("#panel__resources");
        var personas_panel = $("#panel__personas");
        var brand_bar = $("#brand__bar");
        var search_toggle = $("#toggle__search");
        var search_panel = $("#panel__search");

        //--------------------------------------------------------------------------

        var resources_toggle = $("#toggle__resources");
        $("#menu--resources a").attr("tabindex", "-1");

        // Toggle resources panel when tapping button
        resources_toggle.click(function () {
            var panel_height = resources_panel.outerHeight();

            if (
                $("#menu--primary").length > 0 &&
                $(this).hasClass("toggle__resources--active")
            ) {
                resources_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__resources--active");
                resources_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__resources--active");
                brand_bar.removeAttr("style");
                $("#menu--resources a").attr("tabindex", "-1");
                logins_toggle.removeAttr("tabindex");
                personas_toggle.removeAttr("tabindex");
                search_toggle.removeAttr("tabindex");
                $(".search-input").removeAttr("tabindex");
                $(".search-button").removeAttr("tabindex");
            } else if (
                $("#menu--primary").length < 1 &&
                $(window).width() > 959 &&
                $(this).hasClass("toggle__resources--active")
            ) {
                resources_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__resources--active");
                resources_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__resources--active");
                brand_bar.removeAttr("style");
                logins_toggle.removeAttr("tabindex");
                personas_toggle.removeAttr("tabindex");
                search_toggle.removeAttr("tabindex");
                $(".search-input").removeAttr("tabindex");
                $(".search-button").removeAttr("tabindex");
            } else {
                logins_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__logins--active");
                logins_toggle.attr("tabindex", "-1");
                logins_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__logins--active");
                personas_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__personas--active");
                personas_toggle.attr("tabindex", "-1");
                personas_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__personas--active");
                search_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__search--active");
                search_toggle.attr("tabindex", "-1");
                $(".search-input").attr("tabindex", "-1");
                $(".search-button").attr("tabindex", "-1");
                search_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__search--active");

                resources_toggle
                    .attr("aria-pressed", "true")
                    .addClass("toggle__resources--active");
                resources_panel
                    .attr("aria-expanded", "true")
                    .addClass("panel__resources--active");
                brand_bar.css("margin-top", panel_height);
                $("#menu--resources a").removeAttr("tabindex");
            }

            $("#menu--resources").on("focusout", function (event) {
                if (!this.contains(event.relatedTarget)) {
                    resources_panel
                        .removeClass("panel__resources--active")
                        .attr("aria-expanded", "false");
                    resources_toggle
                        .removeClass("toggle__resources--active")
                        .attr("aria-pressed", "false");
                    brand_bar.removeAttr("style");
                    logins_toggle.removeAttr("tabindex").focus();
                    personas_toggle.removeAttr("tabindex").focus();
                    search_toggle.removeAttr("tabindex");
                    $(".search-input").removeAttr("tabindex");
                    $(".search-button").removeAttr("tabindex");
                }
            });
        });

        //--------------------------------------------------------------------------

        var logins_toggle = $("#toggle__logins");
        $("#menu--logins a").attr("tabindex", "-1");

        // Toggle resources panel when tapping button
        logins_toggle.click(function () {
            var panel_height = logins_panel.outerHeight();

            if (
                $("#menu--primary").length > 0 &&
                $(this).hasClass("toggle__logins--active")
            ) {
                logins_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__logins--active");
                logins_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__logins--active");
                brand_bar.removeAttr("style");
                $("#menu--logins a").attr("tabindex", "-1");
            } else if (
                $("#menu--primary").length < 1 &&
                $(window).width() > 959 &&
                $(this).hasClass("toggle__logins--active")
            ) {
                logins_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__logins--active");
                logins_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__logins--active");
                brand_bar.removeAttr("style");
            } else {
                resources_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__resources--active");
                resources_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__resources--active");
                personas_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__personas--active");
                personas_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__personas--active");
                search_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__search--active");
                search_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__search--active");
                search_toggle.attr("tabindex", "-1");
                $(".search-input").attr("tabindex", "-1");
                $(".search-button").attr("tabindex", "-1");
                logins_toggle
                    .attr("aria-pressed", "true")
                    .addClass("toggle__logins--active");
                logins_panel
                    .attr("aria-expanded", "true")
                    .addClass("panel__logins--active");
                brand_bar.css("margin-top", panel_height);
                $("#menu--logins a").removeAttr("tabindex");
            }

            $("#menu--logins").on("focusout", function (event) {
                if (!this.contains(event.relatedTarget)) {
                    logins_panel
                        .removeClass("panel__logins--active")
                        .attr("aria-expanded", "false");
                    logins_toggle
                        .removeClass("toggle__logins--active")
                        .attr("aria-pressed", "false");
                    brand_bar.removeAttr("style");
                    search_toggle.removeAttr("tabindex").focus();
                    $(".search-input").removeAttr("tabindex");
                    $(".search-button").removeAttr("tabindex");
                }
            });
        });

        var personas_toggle = $("#toggle__personas");
        $("#menu--personas a").attr("tabindex", "-1");

        // Toggle resources panel when tapping button
        personas_toggle.click(function () {
            var panel_height = personas_panel.outerHeight();

            if (
                $("#menu--primary").length > 0 &&
                $(this).hasClass("toggle__personas--active")
            ) {
                personas_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__personas--active");
                personas_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__personas--active");
                brand_bar.removeAttr("style");
                $("#menu--personas a").attr("tabindex", "-1");
            } else if (
                $("#menu--primary").length < 1 &&
                $(window).width() > 959 &&
                $(this).hasClass("toggle__personas--active")
            ) {
                personas_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__personas--active");
                personas_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__personas--active");
                brand_bar.removeAttr("style");
            } else {
                resources_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__resources--active");
                resources_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__resources--active");
                logins_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__logins--active");
                logins_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__logins--active");
                search_toggle
                    .attr("aria-pressed", "false")
                    .removeClass("toggle__search--active");
                search_panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel__search--active");
                search_toggle.attr("tabindex", "-1");
                $(".search-input").attr("tabindex", "-1");
                $(".search-button").attr("tabindex", "-1");
                personas_toggle
                    .attr("aria-pressed", "true")
                    .addClass("toggle__personas--active");
                personas_panel
                    .attr("aria-expanded", "true")
                    .addClass("panel__personas--active");
                brand_bar.css("margin-top", panel_height);
                $("#menu--personas a").removeAttr("tabindex");
            }

            $("#menu--personas").on("focusout", function (event) {
                if (!this.contains(event.relatedTarget)) {
                    personas_panel
                        .removeClass("panel__personas--active")
                        .attr("aria-expanded", "false");
                    personas_toggle
                        .removeClass("toggle__personas--active")
                        .attr("aria-pressed", "false");
                    brand_bar.removeAttr("style");
                    search_toggle.removeAttr("tabindex").focus();
                    $(".search-input").removeAttr("tabindex");
                    $(".search-button").removeAttr("tabindex");
                }
            });
        });
    }

    function destroyBrandBar() {
        var site_title = $("#site__title");
        var logo_bar = $("#site__bar--logo");
        var menu_bar = $("#site__bar--menu");
        var alert_toggle = $("#toggle__alert");
        var search_toggle = $("#toggle__search");
        var search_panel = $("#panel__search");
        var site_bar = $("#site__bar");
        var menu_toggle_html =
            '<button id="toggle__menu" class="toggle__menu">Menu</button>';

        // Move search panel back to original location
        search_panel.prependTo(site_bar);

        // Register menu toggle
        site_title.appendTo(site_bar.find("> .wrapper"));
        alert_toggle.appendTo(site_bar.find("> .wrapper"));
        search_toggle.appendTo(site_bar.find("> .wrapper"));
        site_bar.find("> .wrapper").append(menu_toggle_html);

        // Deregister bars
        logo_bar.remove();
    }

    function buildSiteMenu() {
        var header = $("#header-container");
        var site_bar = $("#site__bar");
        var personas_menu = $("#menu--personas");
        var primary_menu = $("#menu--primary");
        var site_menu_html = '<div id="site__menu" class="site__menu">';

        // Register site menu
        site_bar.after(site_menu_html);

        var site_menu = $("#site__menu");

        if (header.hasClass("header-container--university")) {
            primary_menu.unwrap();
        }

        // Move menus from panels to site menu
        primary_menu.appendTo(site_menu);
        //logins_menu.appendTo(site_menu);
        //resources_menu.appendTo(site_menu);
        personas_menu.appendTo(site_menu);
    }

    function destroySiteMenu() {
        var header = $("#header-container");
        var site_title = $("#site__title");
        var site_menu = $("#site__menu");
        var primary_menu = $("#menu--primary");
        var site_bar = $("#site__bar");
        var personas_panel = $("#panel__personas");

        // Add/move components from site menu to site bar
        site_title.appendTo(site_bar.find(".wrapper"));

        if (
            header.hasClass("header-container--university") &&
            !header.hasClass("header--minimal")
        ) {
            var menus = site_bar.find(".wrapper .menus");

            if (menus.length === 0) {
                var menusDiv = $('<div class="menus"></div>');
                menusDiv.append(primary_menu);

                site_bar.find(".wrapper").append(menusDiv);
            } else {
                menus.append(primary_menu);
            }
        } else if (header.hasClass("header-container--persona")) {
            primary_menu.appendTo(site_bar);
        } else {
            primary_menu.appendTo(site_bar);
        }

        var personas_menu = personas_panel.find(".wrapper #menu--personas");
        if (personas_menu.length === 0) {
            $("#menu--personas").appendTo("#panel__personas .wrapper");
        }

        // Deregister site menu
        site_menu.remove();

        // Reset positions on bars
        site_bar.removeAttr("style");
    }

    function buildStickyMenu() {
        var primary_menu = $("#menu--primary");

        // Check to see if we have a primary menu
        if (primary_menu.length && typeof ScrollMagic == "function") {
            // initialize controller
            var controller = new ScrollMagic.Controller({
                addIndicators: false, // toggle to debug (requires plugin)
            });

            // setup scene
            var scene = new ScrollMagic.Scene({
                triggerElement: "#menu--primary",
                triggerHook: 0,
            })
                .setPin("#menu--primary")
                .addTo(controller);
        }
    }

    function destroyStickyMenu() {
        var primary_menu = $("#menu--primary");

        // Check to see if we have a primary menu
        if (primary_menu.length && typeof ScrollMagic == "function") {
            primary_menu.removeAttr("style").unwrap();
        }
    }

    function escapeToggles() {
        $(document).keyup(function (e) {
            var escaped = e.keyCode == 27;
            var active_resources_panel = $("#panel__resources").hasClass(
                "panel__resources--active"
            );
            var active_logins_panel = $("#panel__logins").hasClass(
                "panel__logins--active"
            );
            var active_personas_panel = $("#panel__personas").hasClass(
                "panel__personas--active"
            );
            var active_search_panel = $("#panel__search").hasClass(
                "panel__search--active"
            );
            var active_alerts_panel = $("#panel__alerts").hasClass(
                "panel__alerts--active"
            );

            // If quick links, logins, or search are open,
            // then close them when hitting ESC key
            if (escaped && active_resources_panel) {
                $("#toggle__resources").trigger("click");
            } else if (escaped && active_logins_panel) {
                $("#toggle__logins").trigger("click");
            } else if (escaped && active_personas_panel) {
                $("#toggle__personas").trigger("click");
            } else if (escaped && active_search_panel) {
                $("#toggle__search").trigger("click");
            } else if (escaped && active_alerts_panel) {
                $(".alert__close").trigger("click");
            }
        });
    }

    function subMenus() {
        $(".submenu-toggle").on("click", function () {
            $(".panel__mega").removeClass("panel__mega--active");
            $(this).next(".panel__mega").addClass("panel__mega--active");
        });

        $(".submenu-toggle").on("keypress", function () {
            $(".panel__mega").removeClass("panel__mega--active");
            $(this).next(".panel__mega").addClass("panel__mega--active");
        });

        $(".current-page-ancestor")
            .find(".panel__mega")
            .addClass("panel__mega--active");
    }

    function closeSubMenu() {
        $(".menu-item-has-children").removeClass("open");
        $(".submenu-toggle").attr("aria-expanded", "false");
    }

    function keyboardNav() {
        $(".submenu-toggle").on("click", function () {
            $(this)
                .parent($(".menu-item-has-children"))
                .siblings($(".menu-item-has-children"))
                .removeClass("open");
            $(this)
                .parent($(".menu-item-has-children"))
                .siblings($(".menu-item-has-children"))
                .find($(".submenu-toggle"))
                .attr("aria-expanded", "false");
            if ($(this).parent($(".menu-item-has-children")).hasClass("open")) {
                $(this)
                    .parent($(".menu-item-has-children"))
                    .removeClass("open");
                $(this).attr("aria-expanded", "false");
            } else {
                $(this).parent($(".menu-item-has-children")).addClass("open");
                $(this).attr("aria-expanded", "true");
            }
        });

        $(document).keyup(function (e) {
            if (e.keyCode == 27) {
                closeSubMenu();
            }
        });

        $(".menu-item-has-children > a").on("focus", function () {
            closeSubMenu();
        });

        $("#menu--primary").on("focusout", function (event) {
            if (!this.contains(event.relatedTarget)) {
                $(".menu-item-has-children").removeClass("open");
                $(".submenu-toggle").attr("aria-expanded", "false");
            }
        });
    }

    /* Function addMobileBackMenuItem
  /* Adds a 'back' arrow and link on mobile sub nav panels
    ------------------------------------------------------------------------ */
    function addMobileBackMenuItem() {
        var primaryMenu = $("#primary-menu"),
            subMenu = $("#primary-menu .panel__mega");
        subMenu.prepend(
            '<div class="back"><a href="#"><span class="nav-arrow"></span> Back</a></div>'
        );
        toggleBack();

        function toggleBack() {
            var backLink = $(".panel__mega .back"),
                parentLI = backLink.parents(".panel__mega");
            backLink.on("click", function (e) {
                e.preventDefault();
                parentLI.removeClass("panel__mega--active");
            });
        }
    }

    jQuery(document).ready(function () {
        brandToggles();
        subMenus();
        addMobileBackMenuItem();
        keyboardNav();

        if ($("#menu--primary").length < 1) {
            $("#toggle__menu").on("click", function () {
                $("#panel__resources").toggleClass("panel__resources--active");
                $("#toggle__resources").toggleClass(
                    "toggle__resources--active"
                );

                if ($("#panel__logins").hasClass("panel__logins--active")) {
                    $("#panel__logins").removeClass("panel__logins--active");
                    $("#panel__resources").removeClass(
                        "panel__resources--active"
                    );
                }
            });
        }

        $("#primary-menu").attr("role", "menu");

        $("#colophon-menu").prepend($("#copyright"));
    });

    // Laptop/Desktop:
    // Restructure header to include brand bar and site bar
    enquire.register("screen and (min-width: 1175px)", {
        // =====================================================
        // Triggered when a media query matches
        // =====================================================
        match: function () {
            destroyToggleMenu();
            buildBrandBar();
            destroySiteMenu();
            buildStickyMenu();
        },

        // =====================================================
        // Triggered when a media query transitions from a
        // matched state to an unmatched state
        // =====================================================
        unmatch: function () {
            destroyStickyMenu();
            buildSiteMenu();
            destroyBrandBar();
            buildToggleMenu();
        },

        // =====================================================
        // Triggered once, when the handler is registered
        // =====================================================
        setup: function () {
            buildToggleMenu();
            escapeToggles();
        },
    });
})(jQuery);
